import { createSlice } from '@reduxjs/toolkit';

import {
  getTrainings,
  getSchoolTrainings,
  updateTrainingById,
  removeTrainingById,
} from './actions';

const initialState = {
  data: [] as any[],
  currentPage: 1,
  totalPages: null as any,
  perPage: 10,
};

const trainingsSlice = createSlice({
  name: 'trainings',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getTrainings.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(getSchoolTrainings.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(updateTrainingById.fulfilled, (state: any, action: any) => {
      const { fieldName, updatedTraining } = action.payload;

      return {
        ...state,
        data: state.data.map((training: any) => {
          if (training.id === updatedTraining.id) {
            return {
              ...training,
              [fieldName]: updatedTraining[fieldName],
            };
          }

          return training;
        }),
      };
    });

    builder.addCase(removeTrainingById, (state: any, action: any) => {
      return {
        ...state,
        data: state.data.filter(
          (training: any) => training.id !== action.payload,
        ),
      };
    });
  },
});

export default trainingsSlice.reducer;
